import { cn } from "@/lib/utils";

const MAP = {
  // verdes
  activa: "green", activo: "green", vigente: "green", completo: "green", enviado: "green",
  presentado: "green", liquidado: "green", autorizado: "green", resuelta: "green",
  "al corriente": "green", aprobado: "green", cerrada: "green", "contacto exitoso": "green",
  "conexión simulada exitosa": "green", pagada: "green",
  // ámbar
  media: "amber", medio: "amber", "en proceso": "amber", "en análisis": "amber", "en gestión": "amber",
  pendiente: "amber", próxima: "amber", proxima: "amber", prospecto: "amber", "en gestion": "amber",
  generado: "amber", contactado: "amber", nuevo: "amber", reestructurado: "amber", escalada: "amber",
  escalado: "amber", abierta: "amber", abierto: "amber", "informe en cero": "amber", parcial: "amber",
  // sep-2026 · etapas del ciclo de vida de la solicitud de crédito.
  captura: "amber", "enviada al comité": "amber", "enviada al comite": "amber",
  "liquidado · remanente por devolver": "amber",
  // rojos
  alto: "red", alta: "red", vencido: "red", vencida: "red", incompleto: "red", rechazado: "red",
  cancelada: "red", suspendida: "red", castigado: "red", judicial: "red", incobrable: "red",
  coincidencia: "red", extemporáneo: "red", "preventiva": "blue",
  // azules
  bajo: "blue", baja: "blue", "sofom enr": "green", reportada: "blue", contratado: "blue",
  dispersado: "blue", administrativa: "blue", extrajudicial: "amber", convenio: "blue",
  "pld": "blue", "condusef": "blue", "actividad vulnerable": "amber",
};

const STYLES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  blue: "bg-sage/15 text-forest-600 border-sage/40",
  gray: "bg-slate-100 text-slate-600 border-slate-200",
};

// ago-2026 — Etiquetas visibles de valores que se GUARDAN en minúsculas y no se migran.
// El dato canónico en BD sigue siendo el de la izquierda (359 prospectos con "convertido").
const ETIQUETAS = { convertido: "Convertido" };

export function StatusBadge({ value, className }) {
  if (value === undefined || value === null || value === "") return <span className="text-slate-400">—</span>;
  const key = String(value).toLowerCase().trim();
  const color = MAP[key] || "gray";
  const texto = ETIQUETAS[key] || value;
  return (
    <span
      title={String(texto)}
      data-testid={`badge-${key.replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border",
        // ago-2026 — el pill ya no se desborda de su celda: recorta con puntos suspensivos
        // dentro del ancho disponible. El texto completo queda en el `title`. Antes, con los
        // régimenes largos de actividad vulnerable (hasta 63 caracteres), el badge se pintaba
        // encima de la columna vecina.
        "max-w-full overflow-hidden text-ellipsis whitespace-nowrap",
        STYLES[color],
        className
      )}
    >
      <span className="truncate">{String(texto)}</span>
    </span>
  );
}

export function RiskBadge({ value }) {
  const key = String(value || "").toLowerCase();
  const color = key === "alto" ? "red" : key === "medio" ? "amber" : "green";
  const dot = { red: "bg-red-500", amber: "bg-amber-500", green: "bg-emerald-500" }[color];
  return (
    <span
      data-testid={`risk-${key}`}
      className={cn("inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border", STYLES[color])}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", dot)} />
      {value || "—"}
    </span>
  );
}
